import i18n from '@/i18n'
// import BlankLayout from '../../layout/blankLayout.vue'
import Layout from '../layout.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index.vue'

const basePath = '/v-admin/third-integration-config/management'

export default {
  name: 'thirdIntegrationConfigManagement',
  path: `${basePath}`,
  component: Layout,
  redirect: `${basePath}/index`,
  meta: {
    permission: 'PREMIUM_AI_INTERVIEW',
    isInclude: true,
    titleI18nKey: 'admin.company.thirdIntegrationConfigManagement.title.thirdIntegrationConfigManagementTitle',
    menu: {
      get label () {
        return i18n.t('admin.company.thirdIntegrationConfigManagement.title.thirdIntegrationConfigManagementTitle')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    },
    breadcrumb: { hidden: true },
    isNewPage: true
  },
  children: [
    {
      name: 'thirdIntegrationConfigManagementIndex',
      component: Index,
      path: `${basePath}/index`,
      meta: {
        isInclude: true,
        titleI18nKey: 'admin.company.thirdIntegrationConfigManagement.title.thirdIntegrationConfigManagementTitle',
        menu: {
          get label () {
            return i18n.t('admin.company.thirdIntegrationConfigManagement.title.thirdIntegrationConfigManagementTitle')
          },
          group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
        },
        isNewPage: true
      }
    }
  ]
}
